import { render, staticRenderFns } from "./RegulationSection.vue?vue&type=template&id=a9dbf2f4&scoped=true"
import script from "./RegulationSection.vue?vue&type=script&lang=js"
export * from "./RegulationSection.vue?vue&type=script&lang=js"
import style0 from "./RegulationSection.vue?vue&type=style&index=0&id=a9dbf2f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9dbf2f4",
  null
  
)

export default component.exports